document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.querySelector('.moreless-button-more');
    const loadLessButton = document.querySelector('.moreless-button-less');
    const moreText = document.querySelector('.moretext');

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        moreText.style.display = 'block';
        this.style.display = 'none';
      });
    }

    if (loadLessButton) {
      loadLessButton.addEventListener('click', function () {
        moreText.style.display = 'none';
        if (loadMoreButton) {
          loadMoreButton.style.display = 'flex';
        }
      });
    }
  });



  document.addEventListener('DOMContentLoaded', function() {
    const accordionRows = document.querySelectorAll('collapsible-row.accordion');
    
    accordionRows.forEach(row => {
      const details = row.querySelector('details');
      
      details.addEventListener('toggle', function() {
        if (this.open) {
          row.classList.add('open');
        } else {
          row.classList.remove('open');
        }
      });
    });
  });

// for main accordion//



    // var acc = document.getElementsByClassName("accordion");
    // var i;
    
    // for (i = 0; i < acc.length; i++) {
    //   acc[i].addEventListener("click", function() {
    //     this.classList.toggle("active");
    //     var panel = this.nextElementSibling;
    //     if (panel.style.maxHeight) {
    //       panel.style.maxHeight = null;
    //     } else {
    //       panel.style.maxHeight = panel.scrollHeight + "px";
    //     } 
    //   });
    // }



$(document).ready(function(){

//   var acc = document.getElementsByClassName("accordion");

// for (var i = 0; i < acc.length; i++) {
//   acc[i].addEventListener("click", function () {
//     this.classList.toggle("active");
//     var panel = this.nextElementSibling;

//     if (this.classList.contains("active")) {
//       panel.style.height = "100%";
//     } else {
//       panel.style.height = "0";
//     }
//   });
// }


var acc = document.getElementsByClassName("accordion");

for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;

    if (this.classList.contains("active")) {
      panel.setAttribute("style", "max-height: 100% !important;");
    } else {
      panel.setAttribute("style", "max-height: 0;");
    }
  });
}
});


// for main accordion //

$(document).ready(function(){
  $(".KeyBenefitsaccordion .accordion-inner").click(function(){
    $(".KeyBenefitsaccordion .accordion-inner").removeClass("active"); // Remove 'active' from all items
    $(this).addClass("active"); // Add 'active' to the clicked item
  });
});


